
export class Eingang {
    class = "Eingang";
    itemId: string;
    id: number;
    egid: number;
    edid: number;
    strasse: string;
    nummer: number;
    plz: number;
    zustatzziffern: number;
    ort: string;
    geometry: any;
}
export class Wohnung {
    class = "Wohnung";
    itemId: string;
    id: number;
    egid: number;
    edid: number;
    ewid: number;
    nummer: string;
    adminNr: number; // Administrative Wohnungsnummer (WHGNR)
    physNr: number; // Physische Wohnungsnummer (WEINR)
    stockwerk: string;
    lageStockwerk: string; // Lage auf dem Stockwerk (WBEZ)
    status: string;
    statusCode: number;
    geometry: any;
}
export class Gebaeude {
    class = "Gebaeude";
    itemId: string;
    egid: number;
    egrid: string;
    nummer: string;
    bezeichnung: string;
    status: string;
    gemeinde: string;
    gemeindeBfsNr: number;
    gbperCode: number;
    gbperName: string;
    attributes: any;
    flaeche: number;
    geometry: any;
    coordinates: any;
    eingaenge: Eingang[] = [];
    wohnungen: Wohnung[] = [];
    data?: any;
}
